import { createElementVNode as _createElementVNode, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, normalizeStyle as _normalizeStyle, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6447a93e"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "toggle" }, "▼", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CollapseTransition = _resolveComponent("CollapseTransition")!
  const _component_Node = _resolveComponent("Node")!

  return (_ctx.unref(_ctx.visibility) !== _ctx.Visibility.None)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(["infobox", { collapsed: _ctx.unref(_ctx.collapsed), stacked: _ctx.stacked, ..._ctx.unref(_ctx.classes) }]),
        style: _normalizeStyle([
            {
                borderColor: _ctx.unref(_ctx.color),
                visibility: _ctx.unref(_ctx.visibility) === _ctx.Visibility.Hidden ? 'hidden' : undefined
            },
            _ctx.unref(_ctx.style) ?? {}
        ])
      }, [
        _createElementVNode("button", {
          class: "title",
          style: _normalizeStyle([{ backgroundColor: _ctx.unref(_ctx.color) }, _ctx.unref(_ctx.titleStyle) || []]),
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.collapsed.value = !_ctx.unref(_ctx.collapsed)))
        }, [
          _hoisted_1,
          (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.titleComponent)))
        ], 4),
        _createVNode(_component_CollapseTransition, null, {
          default: _withCtx(() => [
            (!_ctx.unref(_ctx.collapsed))
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: "body",
                  style: _normalizeStyle({ backgroundColor: _ctx.unref(_ctx.color) })
                }, [
                  (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.bodyComponent), {
                    style: _normalizeStyle(_ctx.unref(_ctx.bodyStyle))
                  }, null, 8, ["style"]))
                ], 4))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_component_Node, { id: _ctx.id }, null, 8, ["id"])
      ], 6))
    : _createCommentVNode("", true)
}